import AbstractComponent from "./abstract-component";

const createTemplate = (logo, isShowMenu) => {
  return (
    `<div class="main-header__wrap container">
      <button class="main-header__burger burger" data-show-menu="${isShowMenu}" type="button" title="Открыть меню"></button>

      <div class="main-header__left">
        <a class="main-header__logo logo" href="/">
          <img class="logo__img" src="${logo.src}" alt="${logo.title}" width="120" height="30">
        </a>

        <a class="main-header__catalogLink" href="/catalog">
          <button class="main-header__catalogButton button-secondary js--catalogButton" type="button">
          Каталог товаров
          </button>
        </a>
      </div>

    </div>`
  );
};

export default class HeaderLightComponent extends AbstractComponent {
  constructor({logo = ``}) {
    super();

    this._logo = logo;
    this._isShowMenu = false;

    this.onHideMenuHandler = this.onHideMenuHandler.bind(this);
  }

  getTemplate() {
    return createTemplate(this._logo, this._isShowMenu);
  }

  onHideMenuHandler() {
    this._isShowMenu = false;
    this.getElement().querySelector(`.main-header__burger`).dataset.showMenu = this._isShowMenu;
  }

  setBurgerButtonClickHanlder(handler) {
    this.getElement().querySelector(`.main-header__burger`)
    .addEventListener(`click`, (evt) => {
      const button = evt.target;
      this._isShowMenu = !this._isShowMenu;
      button.dataset.showMenu = this._isShowMenu;

      handler(this._isShowMenu);
    });
  }

  setCatalogButtonClickHandler(handler) {
    const buttons = this.getElement().querySelectorAll(`.js--catalogButton`);
    Array.from(buttons).forEach((button) => {
      button.addEventListener(`click`, (evt) => {
        evt.preventDefault();
        handler();
      });
    });
  }
}
